// Car Data Structure - Same as mobile app
// This is a simplified version - full data can be imported from mobile app

export const carData = {
  Suzuki: {
    models: {
      Alto: {
        variants: {
          VX: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          VXR: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "VXR AGS": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "VXL AGS": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Cultus: {
        variants: {
          VXR: ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          VXL: ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "Auto Gear Shift": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Ravi: {
        variants: {
          "Euro II": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Every: {
        variants: {
          VX: ["2020", "2021", "2022", "2023", "2024", "2025"],
          VXR: ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Wagon R": {
        variants: {
          VXR: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          VXL: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          AGS: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Swift: {
        variants: {
          "GL Manual": ["2022", "2023", "2024", "2025"],
          "GL CVT": ["2022", "2023", "2024", "2025"],
          "GLX CVT": ["2022", "2023", "2024", "2025"],
        },
      },
      Jimny: {
        variants: {
          "GA MT": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Bolan: {
        variants: {
          VX: ["2000", "2005", "2010", "2015", "2017", "2018", "2019", "2020"],
          "Cargo Van": ["2000", "2005", "2010", "2015", "2017", "2018", "2019", "2020"],
        },
      },
      Mehran: {
        variants: {
          VX: ["1989", "1995", "2000", "2005", "2010", "2015", "2017", "2018", "2019"],
          VXR: ["1989", "1995", "2000", "2005", "2010", "2015", "2017", "2018", "2019"],
        },
      },
    },
  },
  Honda: {
    models: {
      Accord: {
        variants: {
          "1.5L VTEC Turbo": ["2020", "2021", "2022", "2023", "2024", "2025"],
          Sport: ["2005", "2010", "2015", "2018"],
          EXL: ["2007", "2010", "2016", "2021"],
          Hybrid: ["2017", "2020", "2022"],
        },
      },
      "BR-V": {
        variants: {
          "i-VTEC S": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          S: ["2016", "2018", "2020", "2021"],
          Prestige: ["2017", "2019", "2022"],
        },
      },
      Civic: {
        variants: {
          Oriel: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          RS: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "VTi Oriel Prosmatec": ["2016", "2017", "2018", "2019", "2020", "2021"],
          "Turbo RS": ["2022", "2023", "2024", "2025"],
          LX: ["2010", "2015", "2020", "2021", "2022"],
          EX: ["2012", "2015", "2018", "2020", "2023"],
          Touring: ["2011", "2015", "2017", "2020", "2022"],
          Sport: ["2015", "2017", "2020", "2021"],
        },
      },
      City: {
        variants: {
          "1.2L M/T": ["2021", "2022", "2023", "2024", "2025"],
          "1.2L CVT": ["2021", "2022", "2023", "2024", "2025"],
          "1.5L CVT": ["2021", "2022", "2023", "2024", "2025"],
          "1.5L ASPIRE M/T": ["2021", "2022", "2023", "2024", "2025"],
          "1.5L ASPIRE CVT": ["2021", "2022", "2023", "2024", "2025"],
          DX: ["2005", "2010", "2015", "2018"],
          LX: ["2007", "2012", "2016", "2020"],
          EX: ["2009", "2014", "2017", "2021"],
          RS: ["2012", "2015", "2019", "2022"],
        },
      },
      "HR-V": {
        variants: {
          VTi: ["2022", "2023", "2024", "2025"],
          "VTi-S": ["2022", "2023", "2024", "2025"],
          LX: ["2015", "2018", "2020", "2022"],
          EX: ["2016", "2019", "2021"],
          Sport: ["2017", "2020", "2023"],
        },
      },
      Fit: {
        variants: {
          "1.5 EXECUTIVE": ["2020", "2021", "2022", "2023", "2024", "2025"],
          Hybrid: ["2015", "2016", "2017", "2018", "2019", "2020"],
          RS: ["2015", "2016", "2017", "2018", "2019", "2020"],
          DX: ["2007", "2010", "2015"],
          LX: ["2009", "2012", "2017"],
          EX: ["2011", "2016", "2019"],
          Sport: ["2013", "2018", "2020"],
        },
      },
      "CR-V": {
        variants: {
          "2.0 CVT": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          LX: ["2011", "2015", "2020", "2021", "2022"],
          EX: ["2013", "2017", "2020", "2021", "2022"],
          Touring: ["2012", "2017", "2020", "2021"],
          "EX-L": ["2014", "2018", "2020", "2022"],
        },
      },
      Vezel: {
        variants: {
          "e-HEV Play": ["2021", "2022", "2023", "2024", "2025"],
          "Hybrid Z": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
          "Hybrid X": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
          "Hybrid RS": ["2016", "2017", "2018", "2019", "2020", "2021"],
        },
      },
    },
  },
  Toyota: {
    models: {
      Corolla: {
        variants: {
          "1.6 XLI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.6 GLI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.8 Altis": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.8 Altis Grande": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          XLI: ["2010", "2015", "2020", "2021"],
          GLI: ["2012", "2016", "2020", "2022"],
          Altis: ["2014", "2018", "2021"],
        },
      },
      "Corolla Cross": {
        variants: {
          "1.8 Hybrid": ["2022", "2023", "2024", "2025"],
          "1.8 V": ["2022", "2023", "2024", "2025"],
        },
      },
      Camry: {
        variants: {
          "2.5 Hybrid": ["2020", "2021", "2022", "2023", "2024", "2025"],
          "2.5 V": ["2020", "2021", "2022", "2023", "2024", "2025"],
          XLE: ["2015", "2018", "2020", "2022"],
          SE: ["2016", "2019", "2021"],
        },
      },
      Yaris: {
        variants: {
          "1.3 M/T": ["2020", "2021", "2022", "2023", "2024", "2025"],
          "1.3 CVT": ["2020", "2021", "2022", "2023", "2024", "2025"],
          "1.5 CVT": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Land Cruiser": {
        variants: {
          "V8 4.5": ["2015", "2018", "2020", "2022", "2023", "2024", "2025"],
          "V8 4.6": ["2016", "2019", "2021", "2023"],
        },
      },
      "Fortuner": {
        variants: {
          "2.7 G": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.7 V": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.8 G": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.8 V": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Hilux": {
        variants: {
          "Single Cab": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "Double Cab": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Prius": {
        variants: {
          Hybrid: ["2015", "2018", "2020", "2022"],
        },
      },
    },
  },
  Hyundai: {
    models: {
      Elantra: {
        variants: {
          "1.6 GLS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.6 GLX": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.8 GLS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Sonata: {
        variants: {
          "2.0 GLS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.4 GLS": ["2018", "2019", "2020", "2021", "2022"],
        },
      },
      Tucson: {
        variants: {
          "2.0 GLS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.0 GLX": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.4 GLS": ["2018", "2019", "2020", "2021", "2022"],
        },
      },
      "Santa Fe": {
        variants: {
          "2.2 CRDi": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Accent: {
        variants: {
          "1.4 M/T": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.4 CVT": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Kia: {
    models: {
      Sportage: {
        variants: {
          "2.0 GLS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "2.0 GLX": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Picanto: {
        variants: {
          "1.0 M/T": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "1.0 CVT": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      Sorento: {
        variants: {
          "2.2 CRDi": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  BMW: {
    models: {
      "3 Series": {
        variants: {
          "320i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "330i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "5 Series": {
        variants: {
          "520i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "530i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "X1": {
        variants: {
          "sDrive18i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "X3": {
        variants: {
          "xDrive20i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  "Mercedes-Benz": {
    models: {
      "C-Class": {
        variants: {
          "C200": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "C300": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "E-Class": {
        variants: {
          "E200": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "E300": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "GLC": {
        variants: {
          "GLC200": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          "GLC300": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Audi: {
    models: {
      "A3": {
        variants: {
          "1.4 TFSI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "A4": {
        variants: {
          "2.0 TFSI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Q3": {
        variants: {
          "2.0 TFSI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Q5": {
        variants: {
          "2.0 TFSI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Nissan: {
    models: {
      "Altima": {
        variants: {
          "2.5 S": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "Sentra": {
        variants: {
          "1.6 M/T": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  MG: {
    models: {
      "HS": {
        variants: {
          "1.5 Turbo": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
      "ZS": {
        variants: {
          "1.5 CVT": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Changan: {
    models: {
      "Alsvin": {
        variants: {
          "1.4 M/T": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  FAW: {
    models: {
      "V2": {
        variants: {
          "1.0": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Peugeot: {
    models: {
      "2008": {
        variants: {
          "1.2 Turbo": ["2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Ford: {
    models: {
      "Ranger": {
        variants: {
          "2.2 XL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
  Mitsubishi: {
    models: {
      "Lancer": {
        variants: {
          "1.6 M/T": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
        },
      },
    },
  },
};

